export default {
    init() {
        // eslint-disable-next-line no-undef
        var ajax_url = ajax_object.ajax_url;
        if($('.template-request-test-drive').length > 0){
            $('#city').on('change',function(){
                var val = $(this).val();
                if(val > 0){
                    $('#dealer').find('option').hide();
                    $('#dealer option:first').show();
                    $('#dealer').find('[data-city='+val+']').show();
                    $('#dealer option').removeAttr('selected');
                    $('#dealer option:first').attr('selected','selected');
                    $('#SelectDealer').show();
                }else{
                    $('#SelectDealer').hide();
                }
            });

            $('#vehicle').on('change',function(){
                if($(this).find('option:selected').val() > 0){
                    var VehicleImage = $(this).find('option:selected').data('img');
                    $('.contact-left-img img').attr('src',VehicleImage);
                }else{
                    $('#VehicleInformation').hide();
                }
            });


            $('#dealerr').on('change',function(){
                if($(this).find('option:selected').val() > 0){

                    var DealerName = $(this).find('option:selected').data('title');
                    $('#DealerName').html(DealerName);

                    var DealerEmail = $(this).find('option:selected').data('email');
                    $('#DealerEmail').html(DealerEmail);

                    var DealerAddress = $(this).find('option:selected').data('address');
                    $('#DealerAddress').html(DealerAddress);

                    var DealerAddress2 = $(this).find('option:selected').data('address2');
                    $('#DealerAddress2').html(DealerAddress2);

                    var DealerProvince = $(this).find('option:selected').data('province');
                    $('#DealerProvince').html(DealerProvince);


                    $('#DealerInformation').show();
                    $('#SelectDealer').hide();
                    $('#SelectCity').hide();
                }else{
                    $('#DealerInformation').hide();
                }
            });

            $('#reset-dealer-information').on('click',function(e){
                e.preventDefault();
                $('#DealerInformation').hide();
                $('#SelectCity').show();
                $('#SelectCity option:first').attr('selected','selected');
                $('#SelectDealer option:first').attr('selected','selected');
            });

            $('#RequestTestDrive').on('submit',function(e){
                e.preventDefault();
                $('#error').hide();
                $('#success').hide();
                $('#RequestTestDrive').find('button').addClass('loading');
                $('#RequestTestDrive').find('button').attr('disabled',true);
                $('#RequestTestDrive').find('button').html('<span>Submiting</span>');

                var formData = new FormData($('#RequestTestDrive')[0]);
                formData.append('action','requestTestDriveCallback');
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function() {
                    if (this.readyState == 4 && this.status == 200) {
                        var data = JSON.parse(this.responseText);
                        // eslint-disable-next-line no-undef
                        grecaptcha.reset();
                        if (data.status == 1 || data.status == '1') {
                            $('#success').html(data.message);
                            $('#success').show();
                        }else{
                            $('html, body').animate({
                                scrollTop: $('#RequestTestDrive').offset().top,
                            }, 2000);
                            $('#error').html(data.html);
                            $('#error').show();
                        }

                        $('#RequestTestDrive').find('button').removeClass('loading');
                        $('#RequestTestDrive').find('button').removeAttr('disabled');
                        $('#RequestTestDrive').find('button').html('<span>Submit</span>');
                    }
                };
                xhttp.open('POST', ajax_url, true);
                xhttp.send(formData);
            });

        }
    },
    finalize() {
        // JavaScript to be fired on the find a retailer page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateRequestTestDrive.js